import { faClose, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useRef } from 'react';

export type AgregarElementoProps = {
	title: string;
	children: React.ReactNode;
	open:boolean;
	onClose:()=>void;
	actionContent?: JSX.Element;
}

const Modal: React.FC<AgregarElementoProps> = ({ title, children, open, onClose, actionContent }) => {

	const ref = useRef<HTMLDialogElement>(null);
	const openModal = useCallback(() => {
		ref.current?.showModal();
	}, [ref, open]);
	const closeModal = useCallback(() => {
		ref.current?.close();
	}, [ref, open]);

	React.useEffect(()=>{
		if(open){
			openModal();
		}else{
			closeModal();
		}
			
	},[open])
	if(!open) return null;
	return (
		<>
			<dialog ref={ref} className='modal-box text-center flex flex-col'>
				<div className='header-modal'>
					<h1 className="text-lg font-bold">{title}</h1>
					<button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={onClose}>
						<FontAwesomeIcon icon={faClose}/>
					</button>
				</div>
				<div className='content-modal overflow-y-auto h-full'>
					{children}
				</div>
				{
					actionContent
						? actionContent
						: <div className='action-modal'></div>
				}
				
			</dialog>
		</>
		
	)
};

export default Modal;
